import axios from "@/libs/api.request";
// 获取批量信息
export const getList = params => {
  return axios.request({
    url: "/finance/AirExtractOutbound/index",
    method: "GET",
    params
  });
};
// 获取单个信息
export const getDetails = id => {
  return axios.request({
    url: `/finance/payment/${id}`,
    method: "GET"
  });
};
// 删除
export const del = id => {
  return axios.request({
    url: `/finance/payment/${id}`,
    method: "DELETE"
  });
};
// 修改
export const update = data => {
  return axios.request({
    url: `/finance/payment/${data.id}`,
    method: "PUT",
    data
  });
};
// 创建账单
export const create_bill = params => {
  return axios.request({
    url: "/finance/AirExtractOutbound/create_bill",
    method: "get",
    params
  });
};


export const Detail = (id) => {
  return axios.request({
    url: `/finance/AirExtractOutbound/detail/`+id,
    method: "get",
  });
};